// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setWhitepaperData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { get_whitepaper } from "http/components/Whitepaper";
import TableWhitepapersData from "./components/Table";
import AddWhitepapersData from "./components/Add";

export default function WhitepaperData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const { whitepaper } = useSelector((state) => ({
    whitepaper: state.mngr.whitepaper,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (whitepaper) getData();
  }, [whitepaper]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_whitepaper();
    if (CheckApiStatus(response)) {
      setData(response.data);
    }
    dispatch(setWhitepaperData(false));
    dispatch(HandleLoading(false));
  };

  return (
    <Grid2 container spacing={2}>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper label={"New Whitepaper"} content={<AddWhitepapersData />} />
      </Grid2>
      <Grid2 item size={{ xs: 12 }}>
        <MPaper
          label={"Whitepapers list"}
          content={<TableWhitepapersData data={data} />}
          defaultExpanded={true}
        />
      </Grid2>
    </Grid2>
  );
}
